import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RequestError} from "../Entity/RequestError";
import {AppThunk} from "../../app/store";
import {User, UserAddresses, UserData, UserDto} from "../Entity/User";
import {
  addItemInWishListRep, addUserAddressRep, deleteUserAddressRep,
  getUserAccountRep, getUserAddressRep,
  getUserCatalogRep, postCustomerRegister,
  postUserLogin,
  resetPasswordRequest, sendContactFormToBo,
  setNewPasswordRequest, subscrireToNewsletterRep, updatePersonRep, updateUserAddressRep
} from "../Repository/UserRepository";
import {ResetPassword} from "./ChangePassword/AskNewPasswordTypes";
import {GetCurrentLocale} from "../../components/Utils";
import t from "../../components/I18N/TranslateHelpers";
import {BASE_API_URL} from "../../app/AppConfig";
import axios from "axios";
import {LocalParams} from "../../components/LocalParams";
import {CreateAccount} from "./Account/CreateAccountTypes";
import {ContactFormData} from "../Contact/ContactFormType";
import {AssociatedProduct} from "../Entity/Product";
interface UsersState {
  isRequesting: boolean,
  isRequestFailed: boolean,
  isAuthenticated: boolean,
  fromLoginPage: boolean,
  isRequestingNewPassword: boolean,
  isRequestingNewPasswordSuccess: boolean,
  error: RequestError | null,
  userDetail: UserDto|null,
  userCatalog: any[],
  isRequestingRegister: boolean,
  isRequestingAdd: boolean,
  isRequestSuccess: boolean,
  isRequestFailedRegister: boolean,
  isRequestingUpdate: boolean,
  isRequestFailedUpdate: boolean,
  isRequestSuccessUpdate: boolean,
  isRequestingUserAccount: boolean,
  isRequestSuccessUserDetail: boolean,
  isRequestFailedUserDetail: boolean,
  userAddresses: UserAddresses[] | null,
  isRequestingGetSuggestedProducts: boolean,
  isRequestGetSuggestedProductsFailed: boolean,
  isRequestGetSuggestedProductsSuccess: boolean,
  suggestedProducts: AssociatedProduct[] | null
  isRequestingAddNewAddress: boolean,
  isRequestAddNewAddressFailed: boolean,
  isRequestAddNewAddressSuccess: boolean,
  isRequestingGetAddresses: boolean
}

let user = User.create();

const usersInitialState: UsersState = {
  isRequesting: false,
  isRequestFailed: false,
  fromLoginPage: false,
  isRequestingNewPassword: false,
  isRequestingNewPasswordSuccess: false,
  isAuthenticated: user ? user.isAuthenticated() : false,
  error: null,
  userDetail: user !== null ? user.userDto : null,
  userCatalog: [],
  isRequestingRegister: false,
  isRequestingAdd : false,
  isRequestSuccess: false,
  isRequestFailedRegister: false,
  isRequestFailedUpdate: false,
  isRequestingUpdate: false,
  isRequestSuccessUpdate: false,
  isRequestingUserAccount: false,
  isRequestSuccessUserDetail: false,
  isRequestFailedUserDetail: false,
  userAddresses: null,
  isRequestingGetSuggestedProducts: false,
  isRequestGetSuggestedProductsFailed: false,
  isRequestGetSuggestedProductsSuccess: false,
  suggestedProducts: null,
  isRequestAddNewAddressFailed: false,
  isRequestAddNewAddressSuccess: false,
  isRequestingAddNewAddress: false,
  isRequestingGetAddresses: false
}

function startRequest(state: UsersState, action: PayloadAction<boolean>) {
  state.fromLoginPage = action.payload;
  state.isRequesting = true;
  state.isRequestFailed = false;
}

function requestFailed(state: UsersState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.fromLoginPage= false;
  state.isAuthenticated = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function loginSuccess(state: UsersState, {payload}: PayloadAction<UserDto>) {
  state.isRequesting = false;
  state.fromLoginPage = false;
  state.isRequestFailed = false;
  state.isAuthenticated = true;
  state.error = null;
  state.userDetail = payload;
  let user = new User(state.userDetail);
  user.storeParams();
}

function logout(state: UsersState, action: PayloadAction<boolean>) {
  let user = new User(state.userDetail);
  user.deleteParams();
  state.isRequesting = false;
  state.fromLoginPage = false;
  state.isAuthenticated = false;
  state.isRequestFailed = false;
  state.error = null;
  state.userDetail = null;

  if(!action.payload) //Manual logout : reload current page
  {
    window.location.reload();
  }
  else //Expired session : go to login page
  {
    window.location.href = `/${GetCurrentLocale()}${t('url_login')}?expired_session=1`;
  }
}

function startResetPasswordRequest(state: UsersState) {
  state.isRequestingNewPassword = true;
  state.isRequestingNewPasswordSuccess = false;
  state.isRequestFailed = false;
}

function passwordRequestSuccess(state: UsersState) {
  state.isRequestingNewPassword = false;
  state.isRequestingNewPasswordSuccess = true;
  state.isRequestFailed = false;
}

function startCatalogRequest(state: UsersState) {
  state.isRequesting = true;
  state.isRequestFailed = false;
}

function catalogRequestSuccess(state: UsersState, { payload }: PayloadAction<any[]>) {
  state.isRequesting = false;
  state.isRequestFailed = false;
  state.userCatalog = payload;
}

function catalogRequestFailure(state: UsersState, { payload }: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestFailed = true;
  state.error = payload;
}

function resetState(state: UsersState) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = false;
  state.error = null;
}

function startRequestRegister(state: UsersState) {
  state.isRequestingRegister = true;
  state.isRequestFailedRegister = false;
}

function startRequestAddItemInWishlist(state: UsersState) {
  state.isRequestingAdd = true;
  state.isRequestFailed = false;
}
function registerFailed(state: UsersState, action: PayloadAction<any>) {
  state.isRequestingRegister = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function registerSuccess(state: UsersState) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
}

function SuccessAddItemInWishlist(state: UsersState) {
  state.isRequesting = false;
  state.isRequestingAdd = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
}

function startUpdateRequest(state: UsersState) {
  state.isRequestingUpdate = true;
  state.isRequestFailedUpdate = false;
}

function updateFailed(state: UsersState, action: PayloadAction<any>) {
  state.isRequestingUpdate = false;
  state.isRequestSuccessUpdate = false;
  state.isRequestFailedUpdate = true;
  state.error = action.payload;
}
function updateSuccess(state: UsersState) {
  state.isRequestingUpdate = false;
  state.isRequestSuccessUpdate = true;
  state.isRequestFailedUpdate = false;
  state.error = null;
}

function startDeleteRequestRdc(state: UsersState) {
  state.isRequestingUserAccount = true;
  state.isRequestFailedUserDetail = false;
  state.error = null;
  state.userDetail = null;
}
function isRequestingGetAddresses(state: UsersState) {
  state.isRequestingGetAddresses = true;
  state.isRequestFailedUserDetail = false;
  state.error = null;
  state.userDetail = null;
}

function requestFailedRdc(state: UsersState, action: PayloadAction<any>) {
  state.isRequestingUserAccount = false;
  state.isRequestSuccessUserDetail = false;
  state.isRequestFailedUserDetail = true;
  state.error = action.payload;
}

function requestGetSuccessRdc(state: UsersState, action: PayloadAction<UserData>) {
  state.isRequestingUserAccount = false;
  state.isRequestSuccessUserDetail = true;
  state.isRequestFailedUserDetail = false;

  if (!state.userDetail) {
    state.userDetail = {} as UserDto;
  }

  state.userDetail = {
    ...state.userDetail,
    customer: action.payload
  };

  state.error = null;
}


function requestAddressSuccessRdc(state: UsersState, action: PayloadAction<any>) {
  state.isRequestingGetAddresses = false;
  state.isRequestSuccessUserDetail = true;
  state.isRequestFailedUserDetail = false;
  state.userAddresses = action.payload["hydra:member"] as UserAddresses[];
  state.error = null;
}

function requestActivationSuccessRdc(state: UsersState) {
  state.isRequestingUserAccount = false;
  state.isRequestSuccessUserDetail = true;
  state.isRequestFailedUserDetail = false;
  state.error = null;
}

function startRequestGetSuggestedProducts(state: UsersState) {
  state.isRequestingGetSuggestedProducts = true;
  state.isRequestGetSuggestedProductsFailed = false;
  state.error = null;
  state.userDetail = null;
}

function GetSuggestedProductsSuccess(state: UsersState, action: PayloadAction<any>) {
  state.isRequestingGetSuggestedProducts = false;
  state.isRequestGetSuggestedProductsSuccess = true;
  state.isRequestGetSuggestedProductsFailed = false;
  state.suggestedProducts = action.payload["hydra:member"] as AssociatedProduct[];
  state.error = null;
}

function GetSuggestedProductsFailed(state: UsersState, action: PayloadAction<any>) {
  state.isRequestingGetSuggestedProducts = false;
  state.isRequestGetSuggestedProductsSuccess = false;
  state.isRequestGetSuggestedProductsFailed = true;
  state.error = action.payload;
}

function addNewAddressRequest(state: UsersState) {
  state.isRequestingAddNewAddress = true;
  state.isRequestAddNewAddressFailed = false;
  state.error = null;
  state.userDetail = null;
}

function addNewAddressSuccess(state: UsersState, action: PayloadAction<any>) {
  state.isRequestingAddNewAddress = false;
  state.isRequestAddNewAddressSuccess = true;
  state.isRequestAddNewAddressFailed = false;
  state.error = null;
}

function addNewAddressFailed(state: UsersState, action: PayloadAction<any>) {
  state.isRequestingAddNewAddress = false;
  state.isRequestAddNewAddressSuccess = false;
  state.isRequestAddNewAddressFailed = true;
  state.error = action.payload;
}

const usersSlice = createSlice({
    name: 'users',
    initialState: usersInitialState,
    reducers: {
      userLoginRequest: startRequest,
      userLoginSuccess: loginSuccess,
      userLoginFailure: requestFailed,
      userLogoutRequest: logout,
      resetUserPasswordRequest: startResetPasswordRequest,
      resetPasswordDone: passwordRequestSuccess,
      userCatalogRequest: startCatalogRequest,
      userCatalogSuccess: catalogRequestSuccess,
      userCatalogFailure: catalogRequestFailure,
      customerRegisterRequest: startRequestRegister,
      customerRegisterSuccess: registerSuccess,
      customerRegisterFailure: registerFailed,
      customerRegisterReset: resetState,
      customerStartUpdateRequest : startUpdateRequest,
      customerUpdateSuccess: updateSuccess,
      customerUpdateFailure: updateFailed,
      addItemInWishlistRequest: startRequestAddItemInWishlist,
      addItemInWishlistSuccess: SuccessAddItemInWishlist,
      startDeleteRequestAct: startDeleteRequestRdc,
      requestGetSuccessAct: requestGetSuccessRdc,
      requestActivationSuccessAct: requestActivationSuccessRdc,
      requestFailedAct: requestFailedRdc,
      requestAddressesSuccessAct: requestAddressSuccessRdc,
      startGetSuggestedProducts: startRequestGetSuggestedProducts,
      successGetSuggestedProducts: GetSuggestedProductsSuccess,
      failedGetSuggestedProducts: GetSuggestedProductsFailed,
      addNewAddressRequestAct : addNewAddressRequest,
      addNewAddressSuccessAct : addNewAddressSuccess,
      addNewAddressFailedAct : addNewAddressFailed,
      isRequestingGetAddressesAct : isRequestingGetAddresses
    }
  }
)

export const {
  userLoginRequest,
  userLoginSuccess,
  userLoginFailure,
  userLogoutRequest,
  resetUserPasswordRequest,
  resetPasswordDone,
  userCatalogRequest,
  userCatalogSuccess,
  userCatalogFailure,
  customerRegisterRequest,
  customerRegisterSuccess,
  customerRegisterFailure,
  customerRegisterReset,
  customerStartUpdateRequest,
  customerUpdateSuccess,
  customerUpdateFailure,
  addItemInWishlistRequest,
  addItemInWishlistSuccess,
  startDeleteRequestAct,
  requestAddressesSuccessAct,
  requestGetSuccessAct,
  requestFailedAct,
  isRequestingGetAddressesAct,
  addNewAddressRequestAct,
  addNewAddressSuccessAct,
  failedGetSuggestedProducts,
  requestActivationSuccessAct,
  startGetSuggestedProducts,
  successGetSuggestedProducts,
  addNewAddressFailedAct
} = usersSlice.actions;

export default usersSlice.reducer;

export const userLogin = (
  userName: string,
  password: string,
  fromLoginPage: boolean
): AppThunk<Promise<UserDto>> => async dispatch => {
  try {
    dispatch(userLoginRequest(fromLoginPage));

    const { token, customer } = await postUserLogin(userName, password);

    LocalParams.setItem("token", token);
    LocalParams.setItem("customer", JSON.stringify(customer));

    const customerData = await getUserAccountRep();

    const myAccountResponse = await axios.get<{ tokenCart: string | null }>(`${BASE_API_URL}/my-account`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const tokenCart = myAccountResponse.data.tokenCart;
    if (tokenCart) {
      LocalParams.setItem("tokenCart", tokenCart);
    }

    const userDto: UserDto = {
      userName,
      token,
      customer: customerData ?? null,
      firstName: customerData?.firstName ?? null,
      lastName: customerData?.lastName ?? null,
      tokenCart: tokenCart ?? null,
    };

    dispatch(userLoginSuccess(userDto));
    return userDto;

  } catch (err) {
    dispatch(userLoginFailure(err));
    throw err;
  }
};

export const userLogout = (expiredSession: boolean = false): AppThunk => async dispatch => {
  try {
    dispatch(userLogoutRequest(expiredSession));
  } catch (err:any) {
    dispatch(userLoginFailure(err.toString()));
  }
}

export const userResetPasswordRequest = (email: string): AppThunk => async dispatch => {
  try {
    dispatch(resetUserPasswordRequest());
    await resetPasswordRequest(email);
    dispatch(resetPasswordDone());
  } catch (err:any) {
    dispatch(userLoginFailure(err.toString()));
  }
}

export const userSetNewPasswordRequest = (passwords: ResetPassword, passwordResetToken: string): AppThunk => async dispatch => {
  try {
    dispatch(resetUserPasswordRequest());
    await setNewPasswordRequest(passwords, passwordResetToken);
    dispatch(resetPasswordDone());
  } catch (err:any) {
    dispatch(userLoginFailure(err.toString()));
  }
}

export const getUserCatalog = (token: string): AppThunk => async dispatch => {
  try {
    dispatch(userCatalogRequest());
    const catalog: any[] = await getUserCatalogRep(token);
    dispatch(userCatalogSuccess(catalog));
  } catch (err: any) {
    dispatch(userCatalogFailure(err.toString()));
  }
};



export const customerRegister = (formValues: CreateAccount): AppThunk => async (dispatch: (arg0: { payload: any; type: string; }) => void) => {
  try {
    dispatch(customerRegisterRequest())
    await postCustomerRegister(formValues);
    dispatch(customerRegisterSuccess());
  } catch (err) {
    dispatch(customerRegisterFailure(err));
  }
}

export const updatePerson = (formValues: CreateAccount): AppThunk => async (dispatch: (arg0: { payload: any; type: string; }) => void) => {
  try {
    dispatch(customerStartUpdateRequest())
    await updatePersonRep(formValues);
    dispatch(customerUpdateSuccess());
  } catch (err) {
    dispatch(customerUpdateFailure(err));
  }
}
export const updateUserAddress = (addressId: any, newAddress: {
  city: string | null;
  street: string | null;
  countryCode: string | null;
  postcode: string | null
}): AppThunk => async (dispatch: (arg0: { payload: any; type: string; }) => void) => {
  try {
    dispatch(customerStartUpdateRequest())
    await updateUserAddressRep(addressId, newAddress);
    dispatch(customerUpdateSuccess());
  } catch (err) {
    dispatch(customerUpdateFailure(err));
  }
}
export const subscribeToNewsletter = (firstName: string, email: string): AppThunk => async dispatch => {
  try {
    dispatch(customerRegisterRequest())
    await subscrireToNewsletterRep(firstName, email);
    dispatch(customerRegisterSuccess());
  } catch (err) {
    dispatch(customerRegisterFailure(err));
  }
}
export const sendContactForm = (formValues: ContactFormData, userToken: string|null): AppThunk => async dispatch =>{
  try{
    dispatch(customerRegisterRequest())
    await sendContactFormToBo(formValues, userToken);
    dispatch(customerRegisterSuccess());
  }catch (err){
    dispatch(customerRegisterFailure(err));
  }
}

export const addItemInWishList = (productId: string,setProductIdRequest: any): AppThunk => async dispatch =>{
  try{
    dispatch(addItemInWishlistRequest())
    await addItemInWishListRep(productId);
    dispatch(addItemInWishlistSuccess());
    setProductIdRequest(0)
  }catch (err){
    dispatch(customerRegisterFailure(err));
  }
}

export const getUserAccount = (includeFavouriteProducts: boolean = true, includeAssociatedProduct: boolean = true): AppThunk => async dispatch => {
  try {
    const newsApiResponse = await getUserAccountRep(includeFavouriteProducts, includeAssociatedProduct);
    if (newsApiResponse !== undefined) {
      dispatch(requestGetSuccessAct(newsApiResponse));
    }
  } catch (err) {
    dispatch(requestFailedAct(err));
  }
}

export const getUserAddress = (): AppThunk => async dispatch => {
  try {
    dispatch(isRequestingGetAddressesAct());
    const newsApiResponse = await getUserAddressRep();
    dispatch(requestAddressesSuccessAct(newsApiResponse));
  } catch (err) {
    dispatch(requestFailedAct(err));
  }
}
export const addUserAddress = (address: Partial<UserAddresses>): AppThunk => async dispatch => {
  try {
    dispatch(addNewAddressRequestAct());
    const response = await addUserAddressRep(address); // API call
    dispatch(addNewAddressSuccessAct(response));
    dispatch(getUserAddress());
  } catch (err) {
    dispatch(addNewAddressFailedAct(err));
  }
};

export const deleteUserAddress = (id: number): AppThunk => async dispatch => {
  try {
    dispatch(startDeleteRequestAct());
    await deleteUserAddressRep(id);
    dispatch(getUserAddress());
  } catch (err) {
    dispatch(requestFailedAct(err));
  }
}
